import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers/index";
import thunk from 'redux-thunk';

export default configureStore(
    { reducer: reducers, middleware: [thunk], devTools: window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() }
);
